import React from "react";
import { EmblaOptionsType } from "embla-carousel";
import { useDotButton } from "./DotButtons";
import { PrevButton, NextButton, usePrevNextButtons } from "./ArrowButtons";
import useEmblaCarousel from "embla-carousel-react";
import { IOrganisation } from "../Leaders";

type PropType = {
  slides: IOrganisation[];
  options?: EmblaOptionsType;
};

const Carousel: React.FC<PropType> = (props) => {
  const { slides, options } = props;
  const [emblaRef, emblaApi] = useEmblaCarousel(options);

  const { selectedIndex } = useDotButton(emblaApi);

  const {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick,
  } = usePrevNextButtons(emblaApi);

  return (
    <div className="flex flex-1 flex-col justify-center items-center w-full">
      <div className="flex items-center h-full justify-center w-full">
        <div className="w-full mx-auto">
          <div className="overflow-hidden rounded-lg" ref={emblaRef}>
            <div className="flex gap-10 max-w-sm">
              {slides.map((data) => (
                <div
                  className="min-w-fit max-w-72 bg-[#FAF8ED] rounded-lg p-3"
                  key={data.img}
                >
                  <div className="flex items-start justify-center bg-white rounded-xl max-h-56">
                    <img
                      src={data.img}
                      alt=""
                      className="w-full rounded-xl max-w-56"
                    />
                  </div>
                  <div className="flex flex-col gap-1 pt-2 px-3">
                    <h4 className="text-lg lg:text-xl xl:text-3xl font-bold">
                      {data.title}
                    </h4>
                    <p className="text-sm font-light pt-1 lg:text-base xl:text-lg">
                      {data.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="flex justify-between items-center pt-4">
            <div className="flex items-center gap-1 text-xs">
              {selectedIndex + 1}/{slides.length}
            </div>
            <div className="embla__buttons">
              <PrevButton
                onClick={onPrevButtonClick}
                disabled={prevBtnDisabled}
              />
              <NextButton
                onClick={onNextButtonClick}
                disabled={nextBtnDisabled}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Carousel;
